__turbopack_context__.v({
  "button": "styles-module-scss-module__CKqK0q__button",
  "icon": "styles-module-scss-module__CKqK0q__icon",
  "infoRow": "styles-module-scss-module__CKqK0q__infoRow",
  "root": "styles-module-scss-module__CKqK0q__root",
  "text": "styles-module-scss-module__CKqK0q__text",
});
